export const analystSourcesWhiteList: string[] = ['PMF', 'AFRY', 'AURORA', '3MV'];
